import React, { createContext, useContext } from 'react';

import { trpc } from '@/trpc/client';
import type { AppRouterInput } from '@/trpc/server/routers/app.router';

import type { ActiveExperiments, ExperimentKey } from './experiments';

const ExperimentsContext = createContext<ActiveExperiments | undefined>(
  undefined
);

export const ExperimentsProvider = (props: {
  /**
   * Flags fetched on initial render.
   */
  initialFlags?: ActiveExperiments;
  context?: AppRouterInput['flags']['activeExperiments'];

  children: React.ReactNode;
}) => {
  const { data } = trpc.flags.activeExperiments.useQuery(props.context);

  const flags = data ?? props.initialFlags;

  return (
    <ExperimentsContext.Provider value={flags}>
      {props.children}
    </ExperimentsContext.Provider>
  );
};

/**
 * This is temporary - need something quick and dirty for the banner.
 * In future will use the feature flag system already in place (useFeatureSwitchStatus).
 */
export function useExperiments() {
  return useContext(ExperimentsContext);
}

export function useExperimentStatus(key: ExperimentKey) {
  return Boolean(useExperiments()?.[key]);
}
